import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';
import {responseResolveInterceptor} from './interceptors';

export function getMemberWallet(params = {}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wallet/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberWallet.js